import 'select2';
import 'select2/dist/css/select2.css';

$(() => {
    $('.js_component_select_single').select2({
        width: '100%'
    });

    $('.js_component_select_multiple').select2({
        width: '100%',
        templateSelection: (item) => item.text.slice().replace('... ', '')
    });

    $('.js_toolbar .js_component_select_single[name="limit"]').on('select2:select', (e) => {
        let url = new URL(document.location);
        let params = new URLSearchParams(url.search);
        params.set('limit', parseInt(e.params.data.text));
        document.location = '?' + params.toString();
    });
});